import { ActionTypes } from "./actions.js";
import { getInitialState } from "./state.js";
const initialState = getInitialState();
const reducer = (state = initialState, action) => {
    switch (action.type) {
        case ActionTypes.set:
            return {
                ...state,
                sanctions: action.payload.sanctions
            };
        case ActionTypes.reset:
            return getInitialState();
        default:
            return state;
    }
};
export { reducer, getInitialState };
